// Los temas del gestor (2026-10-06). Los estilos están en temas.css; acá sólo
// el nombre que se muestra y tres colores para la muestra del selector.
export const TEMAS = [
  { id: `vanguard`, nombre: `Vanguard`, ayuda: `El de la app, en claro u oscuro`, muestra: [`#3c4651`, `#558ba5`, `#f5fcff`] },
  { id: `enfoque`, nombre: `Enfoque`, ayuda: `Denso y monoespaciado; sigue claro/oscuro`, muestra: [`#14191e`, `#6ba6c2`, `#e8edf2`] },
  { id: `minimalista`, nombre: `Minimalista`, ayuda: `Blanco, negro y aire; sigue claro/oscuro`, muestra: [`#ffffff`, `#111111`, `#efefef`] },
  { id: `matrix`, nombre: `Matrix`, ayuda: `Terminal verde de desarrollador`, muestra: [`#020703`, `#39ff7a`, `#0f3a1c`] },
  { id: `animado`, nombre: `Animado`, ayuda: `Color que fluye y movimiento`, muestra: [`#cffafe`, `#2563eb`, `#ecfccb`] },
  { id: `papel`, nombre: `Papel`, ayuda: `Sepia y serif, para leer mucho`, muestra: [`#f4ecd8`, `#8b5e34`, `#3b2f20`] },
  { id: `neon`, nombre: `Neón`, ayuda: `Noche azul con cian y violeta`, muestra: [`#0a0f1f`, `#22d3ee`, `#a78bfa`] },
];

export const nombreTema = (id) => TEMAS.find((t) => t.id === id)?.nombre ?? id;
